module.exports = __webpack_public_path__ + "img/resources-1440.88755116.jpg";